import * as React from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import Card from '@mui/material/Card';
import Icn from './Icn';
import IconBtn from './IconBtn';
import { colors } from '../maps/colors';
import FloorDialog from './floorBuilder/FloorDialog';
import EdgeStatus from "./EdgeStatus";
import useZibi from "../zibi/UseZibi";
import { addOrDeleteQueryParams, getQueryValue } from "../domain/queryHandler";
import IconButton from '@mui/material/IconButton';
import QRCode from "react-qr-code";
import Dialog from '@mui/material/Dialog';
import { useState } from 'react';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Tx from './Tx';
import PlayBoxDialog from "./dialogs/PlayBoxDialog";
import { api } from "../maps/data.js";

export default function InstallerEdgeCard(props) {
    const navigate = useNavigate();
    const location = useLocation();

    const [sensorStatuses] = useZibi('sensorStatuses');
    const [openQR, s_openQR] = useState(false);
    const { floor, floorName, selectedSiteType } = props;

    const changeUrl = (query) => {
        navigate({
            search: query
        });
    }

    const restartEdge = async () => {
        await api({
            type: 'restartEdge',
            data: {
                edgeId: props._id,
                siteId: props.siteId
            }
        });
    }

    const open_floor = getQueryValue(location, 'buildFloorDialog') === props._id;
    const boxPlayMode = getQueryValue(location, 'boxPlayMode') === props._id;
    const servicesStatuses = sensorStatuses?.[props?._id]?.services;

    return (
        <Card onClick={props.onClick} sx={{ position: "relative", width: '100%', marginBottom: '5px', background: props.selected ? colors.LIGHT_GREEN + "50" : 'white' }}>
            <div style={{padding: 5}}>
                <Icn style={{position: 'relative', top: 4}}>edge</Icn> <span
                style={{fontSize: 18, fontWeight: 500}}>{floorName}</span>
                <div>
                    <b>{props.number}</b>
                </div>
                <div style={{
                    background: colors.LIGHT_GREEN,
                    display: 'inline-block',
                    padding: '0 5px',
                    fontWeight: 'bold'
                }}>
                    {props.softwareType}
                </div>
                <div style={{
                    background: colors.ORANGE,
                    display: 'inline-block',
                    padding: '0 5px',
                    fontWeight: 'bold'
                }}>
                    {props.serviceType}
                </div>
                <div style={{fontSize: 8}}>
                    {props._id}
                </div>
                <div style={{fontSize: 12}}>
                    IP: {props.edgeIp}
                </div>
                <div style={{fontSize: 12}}>
                    Internal IP: {props.internalEdgeIp}
                </div>
                <div style={{fontSize: 12}}>
                    Udp address: {props.udpAddr ? props.udpAddr : props.edgeIp}
                </div>
            </div>
            {
                servicesStatuses && (
                    <EdgeStatus
                        services={servicesStatuses}
                    />
                )
            }
            <div style={{padding: 5}}>
                {props.softwareType === 'BOX' && (
                    <IconBtn
                        customtheme="small-gray"
                        size="small"
                        style={{ color: colors.GREEN }}
                        onClick={(e) => {
                            e.stopPropagation();
                            const urlToPush = addOrDeleteQueryParams(location, [{ boxPlayMode: props._id }]);
                            changeUrl(urlToPush);
                        }}
                    >play</IconBtn>
                )}
                <IconBtn customtheme="small-gray" size="small" onClick={props.onEdit}>edit</IconBtn>
                <IconBtn customtheme="small-gray" size="small" style={{ marginLeft: 5 }}>delete</IconBtn>
                <IconBtn customtheme="small-gray" size="small" style={{ marginLeft: 5, color: colors.GREEN }} onClick={(e) => {
                    e.stopPropagation();
                    const urlToPush = addOrDeleteQueryParams(location, [{ buildFloorDialog: props._id }]);
                    changeUrl(urlToPush);
                }}>floor</IconBtn>
                <IconBtn
                    onClick={(e) => {
                        e.stopPropagation();
                        restartEdge();
                    }}
                    customtheme="small-gray" size="small" style={{ marginLeft: 5, color: colors.TEAL }}>
                    restartAltIcon
                </IconBtn>

                {
                    props.softwareType === 'BOX' && props._id && <IconButton size={"normal"} onClick={() => s_openQR(true)}>
                        <QRCode value="zibi" size={18} />
                    </IconButton>
                }
                {
                    openQR && <Dialog fullScreen open={true}>
                        <DialogContent style={{ textAlign: 'center' }}>
                            <div style={{ marginTop: 100, marginBottom: 30 }}>QR CODE</div>
                            <QRCode value={`{"boxId": "${props._id}"}`} size={256} />
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => s_openQR(false)}><Tx>g.close</Tx></Button>
                        </DialogActions>
                    </Dialog>
                }

            </div>
            {
                open_floor && (
                    <FloorDialog onClose={(e) => {
                        e.stopPropagation();
                        const urlToPush = addOrDeleteQueryParams(location, [{ buildFloorDialog: null }]);
                        changeUrl(urlToPush);
                        props.forceGetEdges();
                    }}
                        checkin={props.checkin}
                        checkout={props.checkout}
                        floor={floor}
                        floorName={floorName}
                        edgeId={props._id}
                        siteId={props.siteId}
                        knn={props.knn}
                        selectedSiteType={selectedSiteType}
                    />
                )
            }
            {
                boxPlayMode && (
                    <PlayBoxDialog
                        edgeId={props._id}
                        siteId={props.siteId}
                        onClose={(e) => {
                            e.stopPropagation();
                            const urlToPush = addOrDeleteQueryParams(location, [{ boxPlayMode: null }]);
                            changeUrl(urlToPush);
                        }}
                    />
                )
            }
        </Card>
    );
}